<template>
  <div id="footer">
    <div class="footer_wrap" v-if="test!==1">
      <div class="footer_wrap_one">
        <img src="https://www.dbclass.cn/public/home/images/end_logo.jpg" class="img_one_header" />
        <div class="text_one_content">
          专注视频通讯领域10余年，拥有国内外优秀人才组成的技术研发和管理服务团队，专注于视频通讯平台开发、行业解决方案、系统软硬件集成和运营管理。
        </div>
        <div class="img_two">
          <img src="https://www.dbclass.cn/public/home/images/end_01.jpg" />
        </div>
      </div>
      <div class="public_fuwu">
        <div class="public_fuw_header_text">服务</div>
        <a href="https://www.dbclass.cn/jishu">技术支持</a>
        <a href="https://www.dbclass.cn/kaifazhe">开发者</a>
        <a href="https://www.dbclass.cn/">私有化</a>
        <a href="https://www.dbclass.cn/shequ">社区</a>
      </div>
      <div class="public_fuwu">
        <div class="public_fuw_header_text">下载</div>
        <router-link to="/password-login" class="login_in">登录</router-link>
        <router-link to="/regist" class="login_zhuce">注册</router-link>
        <a href="/">入口</a>
        <a href="/">排课</a>
      </div>
      <div class="public_fuwu">
        <div class="public_fuw_header_text">关于我们</div>
        <a href="https://www.dbclass.cn/about">东博视讯</a>
        <a href="https://www.dbclass.cn/anli.html">客户案例</a>
        <a href="https://www.dbclass.cn/newsLists.html">新闻动态</a>
        <a href="https://www.dbclass.cn/about">联系我们</a>
      </div>
      <div class="public_fuwu">
        <div class="public_fuw_header_text"></div>
        <span>联系邮箱：info@dbtech.cn</span>
        <span>联系地址：青岛市西海岸新区天相国际5栋10层</span>
        <span>邮政编码：264200</span>
      </div>
      <div class="img_wrap_two">
        <img src="https://www.dbclass.cn/public/home/images/end_02.jpg" />
      </div>
      <div class="img_erweibo_code">
        <img src="https://www.dbclass.cn/public/home/images/end_03.jpg" />
        <img src="https://www.dbclass.cn/public/home/images/end_04.jpg" />
      </div>

    </div>
    <div class="end_fot">
      <span>版权所有 © 2012-2020 东博视讯</span>
      <a href="https://www.dbclass.cn/zs.jpg" target="_blank">增值电信业务经营许可证编号B2-20201276</a>
      <a href="https://beian.miit.gov.cn/" target="_self">鲁ICP备09039169号-2 </a> 电话：400-838-5277
    </div>
  </div>
</template>
<script>
export default {
  name: "footers",
  data() {
    return {
      test: ""
    };
  },
  mounted() {
    var browser = {
      versions: (function() {
        var u = navigator.userAgent,
          app = navigator.appVersion;
        return {
          trident: u.indexOf("Trident") > -1,
          presto: u.indexOf("Presto") > -1,
          webKit: u.indexOf("AppleWebKit") > -1,
          gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
          mobile: !!u.match(/AppleWebKit.*Mobile.*/),
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1,
          iPhone: u.indexOf("iPhone") > -1,
          iPad: u.indexOf("iPad") > -1,
          webApp: u.indexOf("Safari") == -1,
          weixin: u.indexOf("MicroMessenger") > -1,
          qq: u.match(/\sQQ/i) == " qq"
        };
      })(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    if (
      browser.versions.mobile ||
      browser.versions.android ||
      browser.versions.ios
    ) {
      this.test = 1;
    }
  }
};
</script>

<style scoped lang="less">
img {
  display: block;
}
.end_fot {
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #9b9b9b;
  margin-top: 48px;
  a {
    color: #9b9b9b;
    margin-left: 4px;
  }
  a:hover {
    color: #fff;
  }
}
#footer {
  padding-bottom: 25px;

  width: 100%;
  background-color: #1c2037;
  .footer_wrap {
    display: flex;
    width: 1208px;
    margin: 0 auto;
    .footer_wrap_one {
      margin-top: 92px;
      .img_two {
        margin-top: 20px;
      }
      .text_one_content {
        width: 198px;
        font-family: MicrosoftYaHei;
        margin-top: 14px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #b1b0b0;
      }
    }
    .public_fuwu:nth-child(2) {
      margin-left: 58px;
    }
    .public_fuwu:nth-child(3) {
      margin-left: 38px;
    }
    .public_fuwu:nth-child(4) {
      margin-left: 60px;
    }
    .public_fuwu:nth-child(5) {
      margin-left: 53px;
    }
  }
  .img_wrap_two {
    margin-top: 90px;
    margin-left: 60px;
  }

  .public_fuwu {
    margin-top: 92px;
    .public_fuw_header_text {
      font-family: MicrosoftYaHei-Bold;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      height: 30px;
      line-height: 24px;
      letter-spacing: 0px;
      color: #ffffff;
    }
    a {
      display: block;
      font-size: 14px;
      color: #b1b0b0;
      line-height: 32px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
    }
    span {
      display: block;
      font-size: 14px;
      color: #b1b0b0;
      line-height: 32px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
    }
  }
  .img_erweibo_code {
    margin-top: 97px;
    img {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footers.vue